import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest, PaginationType } from '../../types/pagination';
import { SortType, WithArchiveRequest } from '../../types/props';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export const promoStatusMap: Record<PromoStatusType, string> = {
  Finished: 'Завершена',
  Active: 'Активна',
  Stopped: 'Не активна',
  Planned: 'Запланирована',
};

export type PromoStatusType = 'Finished' | 'Active' | 'Stopped' | 'Planned';

export type PromotionType = {
  active_from: string;
  active_to: string;
  condition: LangType;
  created_at: string;
  description: LangType;
  id: number;
  image: LangType;
  link: string;
  name: LangType;
  status: PromoStatusType;
  places?: string[] | number[];
  is_deleted?: boolean;
  media?: {
    [key: string]: {
      link: string;
      caption: string;
    };
  };
};

const baseUrl = `${managerApiUrl}/promotion`;

export type FetchPromoListRequest = {
  place_id: number;
  id?: string;
  name?: string;
  description?: string;
  status?: string;
  active_from?: string;
  active_to?: string;
  field?: string;
  dir?: SortType;
} & PaginationRequest &
  WithArchiveRequest;

export const fetchPromoList = async (
  params: FetchPromoListRequest,
): Promise<PaginationType & { promotions: PromotionType[] }> => {
  const response = await baseFetch(baseUrl + buildParams(params));
  return response;
};

export const fetchPromo = async (id: string): Promise<PromotionType> => {
  const response = await baseFetch(baseUrl + `/${id}`);
  return response;
};

export const postPromo = async (params: Partial<PromotionType>): Promise<PromotionType> => {
  const response = await baseFetch(baseUrl, {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response;
};

export const putPromo = async (params: Partial<PromotionType>): Promise<PromotionType> => {
  const response = await baseFetch(baseUrl + `/${params.id}`, {
    method: 'PUT',
    body: JSON.stringify(params),
  });
  return response;
};

export const deletePromo = async (id: string): Promise<void> => {
  await baseFetch(baseUrl + `/${id}`, {
    method: 'DELETE',
  });
};

export const restorePromo = async (id: string): Promise<void> => {
  const response = await baseFetch(baseUrl + `/${id}/restore`, { method: 'POST' });
  return response;
};
